export default __webpack_public_path__ + "static/media/goodEmoji.c56d1865.svg";